import endpoints from "../api/endpoints/index.js";
import AppError from "./AppError.js";
import getMessage from "./getMessage.js";

const getEndpoint = (module, key, ...args) => {
  let endpoint = endpoints?.[module]?.[key];
  if (!endpoint) {
    throw new AppError(
      500,
      getMessage("common", "invalidInput", "eng", `endpoint: ${module}.${key}`),
    );
  }
  return typeof endpoint === "function" ? endpoint(...args) : endpoint;
};

export default getEndpoint;
